import { IIsValidStartPositionOptions } from './isValidStartPosition.types';

export const isValidStartPosition = (opts: IIsValidStartPositionOptions): boolean => {
  const { text, index, allowedSymbols = [' ', '\n'] } = opts;
  return index === 0 || allowedSymbols.includes(text[index - 1]);
};
